export const FAKE_CSTIC_ENABLE_CONFIGURE_CARRIAGE_VALUES = `FAKE_ENABLE_CONFIGURE_CARRIAGE_VALUES`;
export const FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE = `FAKE_LUBRICATION_CONNECTOR_TYPE`;

export const CARRIAGE_LOCATING_CSTIC_NAME = `VANS_065`;
export const CARRIAGE_DETAILS_INFO_MSG = "CARRIAGE_DETAILS_INFO_MSG";

export const CARRIAGE_MIN_STEP_TO_BUY = 1; // counted from 0, so 2nd step
export const CARRIAGE_MIN_STEP_TO_SAVE = 2; // counted from 0, so 3rd step
